/**
 * 主要负责客户详情页面配置信息
 */
// 客户类型：1——个人；2——企业
export const CUSTOMER_TYPE = {
  PERSON: 1,
  ENTERPRISE: 2,
}

export default function () {
  // 从链接上获取是个人客户还是企业客户
  const { customerType } = this.$route.query
  // ---------------------tab部分-------------------------------
  // 个人tab
  const personalCustomerTabs = [
    {
      label: '个人',
      value: 'personalBasic',
    },
    {
      label: '证照',
      value: 'license',
    },
  ]
  // 企业tab
  const enterpriseCustomerTabs = [
    {
      label: '企业',
      value: 'enterpriseBasic',
    },
  ]

  // 差异化tabs；customerType:1 个人客户，2企业客户
  const diffCustomerTabs = {
    [CUSTOMER_TYPE.PERSON]: personalCustomerTabs,
    [CUSTOMER_TYPE.ENTERPRISE]: enterpriseCustomerTabs,
  }

  // 客户公共tabs
  const customerTabs = [
    ...diffCustomerTabs[customerType] || [],
    {
      label: '违章',
      value: 'violation',
    },
    {
      label: '事故',
      value: 'accident',
    },
    {
      label: '维保',
      value: 'maintenance',
    },
    {
      label: '订单',
      value: Number(customerType) === CUSTOMER_TYPE.PERSON ? 'personalOrder' : 'enterpriseOrder',
    },
  ]

  // ----------------------------客户详情通用配置信息--------------------------
  // 推荐人信息
  const recommenderList = [
    { key: 'recommender', name: '推荐方' },
    { key: 'recommenderOpenBank', name: '推荐方开户行' },
    { key: 'recommenderBankCard', name: '推荐方银行卡' },
    { key: 'recommenderRewardAmount', name: '推荐奖励（元）' },
  ]


  return {
    customerTabs,
    recommenderList,
  }
}
